"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextColorStyle = exports.getCssVar = exports.getBackgroundColorStyle = void 0;

/**
 * This function is used to render a valid CSS var syntax:
 * ```
 * style={{ color: getCssVar('config-header-color') }}
 * ```
 */
var getCssVar = function getCssVar(name) {
  return "var(--".concat(name, ")");
};

exports.getCssVar = getCssVar;

var getTextColorStyle = function getTextColorStyle(_ref) {
  var color = _ref.color,
      colorDisplay = _ref.colorDisplay;
  var isTextUnstyled = colorDisplay === undefined && color === undefined;
  var isUserSelectedColor = colorDisplay === 'solid_color' || colorDisplay === undefined;

  if (isTextUnstyled) {
    return undefined;
  }

  if (isUserSelectedColor) {
    return {
      color: color
    };
  } // returns config color(based on the value of community defined css-variable)


  return {
    color: getCssVar(colorDisplay)
  };
};

exports.getTextColorStyle = getTextColorStyle;

var getBackgroundColorStyle = function getBackgroundColorStyle(config) {
  if (!config) {
    return null;
  }

  var backgroundColorDisplay = config.backgroundColorDisplay;

  if (backgroundColorDisplay === 'config--main-color-brand' || backgroundColorDisplay === 'config--main-color-brand-secondary') {
    return {
      backgroundColor: getCssVar(backgroundColorDisplay)
    };
  }

  return null;
};

exports.getBackgroundColorStyle = getBackgroundColorStyle;